const contacts = {
    eyebrow: 'Contact',
    title: 'Say hello',
    description: 'Roles, collaborations or just an interesting problem — send a message and I will get back to you.',
    email: 'Email',
    phone: 'Phone',
    basedIn: 'Based in',
};

export default contacts;
